/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
export const noop = function () {
  return undefined;
};
//# sourceMappingURL=noop.js.map